const GOOGLE_ADS_CONVERSION_SEND_TO = "AW-453587368/98jXCMvnjoIYEKjjpNgB"
const PROVIDER_INTEREST_SUBMITTED_MESSAGE_TYPE = "collar-provider-interest-submitted"

function trackLeadConversion({ dataLayerEvent, method } = {}) {
  if (typeof window === "undefined") return false

  const now = Date.now()
  if (window.__collarLastLeadConversionAt && now - window.__collarLastLeadConversionAt < 2000) {
    return false
  }
  window.__collarLastLeadConversionAt = now

  window.dataLayer = window.dataLayer || []
  if (dataLayerEvent) {
    window.dataLayer.push({ event: dataLayerEvent })
  }

  // Queue the event even if the async Google library has not loaded yet.
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments)
    }

  if (typeof window.oaiq === "function") {
    window.oaiq("measure", "lead_created", { type: "customer_action" })
  }

  window.uetq = window.uetq || []
  window.uetq.push("event", "demo_booked", {
    event_category: "lead",
  })

  // Queue the event even if the async Meta Pixel library has not loaded yet.
  window.fbq =
    window.fbq ||
    function () {
      ;(window.fbq.q = window.fbq.q || []).push(arguments)
    }
  window.fbq("track", "Lead")

  window.gtag("event", "generate_lead", { method: method || "website" })
  window.gtag("event", "conversion", {
    send_to: GOOGLE_ADS_CONVERSION_SEND_TO,
  })

  return true
}

function isProviderInterestSubmittedMessage(event, expectedOrigin) {
  if (!event || !expectedOrigin || event.origin !== expectedOrigin) return false
  return event.data?.type === PROVIDER_INTEREST_SUBMITTED_MESSAGE_TYPE
}

module.exports = {
  GOOGLE_ADS_CONVERSION_SEND_TO,
  PROVIDER_INTEREST_SUBMITTED_MESSAGE_TYPE,
  trackLeadConversion,
  isProviderInterestSubmittedMessage,
}
